import React, { useContext } from 'react'
import styled from 'styled-components'
import { Text } from '@jarvis.oddle/core/components/Typo'
import { TranslationContext } from '@jarvis.oddle/core/components/Translation'
import breakpoint from 'src/utils/styledComponentsBreakpoint'

const ProgressBar = styled.ul`
  ${breakpoint('desktop')`
    margin-top: 30px;
    margin-left: -31px;
  `}
`

const ACTIVE_COLOR = 'rgba(39, 202, 39, 1)'
const DEADACTIVE_COLOR = '#d6d6d6'

const ProgressBarStep = styled.li`
  list-style: none;
  line-height: 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Node = styled.div<{ isDone: boolean }>`
  height: 12px;
  width: 12px;
  margin-bottom: 4px;
  border-radius: 50%;
  display: inline-block;
  transition: all 1000ms ease;
  background-color: ${(props) =>
    props.isDone ? ACTIVE_COLOR : DEADACTIVE_COLOR};
`

const Divider = styled.div<{ isDone: boolean }>`
  height: 40px;
  width: 1px;
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 5.5px;
  transition: all 800ms ease;
  background-color: ${(props) =>
    props.isDone ? ACTIVE_COLOR : DEADACTIVE_COLOR};
`

const StyledTextStatus = styled(Text)<{ isDone: boolean }>`
  min-width: 88px;
  padding-top: 4px;
  text-align: left;
  margin-top: -10px;
  margin-left: 25px;
  font-weight: ${(props) => (props.isDone ? '700' : '400')};
`

interface VerticalDottedStepsBarProps {
  status: string
  listOfStatus: string[]
  steps: Record<string, number>
}

const VerticalDottedStepsBar = ({
  status,
  listOfStatus,
  steps
}: VerticalDottedStepsBarProps): JSX.Element => {
  const { t } = useContext(TranslationContext)
  const numberOfStepDone = steps[status]
  return (
    <ProgressBar data-testid='orderProgressList'>
      {listOfStatus.map((item, i) => {
        return (
          <ProgressBarStep key={item}>
            <Node isDone={i < numberOfStepDone} />
            <StyledTextStatus
              isDone={item === status}
              data-testid={item === status ? 'current' : ''}
            >
              {t(`${item}`)}
            </StyledTextStatus>
            {/* Hide last divider */}
            {i < listOfStatus.length - 1 && (
              <Divider isDone={i < numberOfStepDone} />
            )}
          </ProgressBarStep>
        )
      })}
    </ProgressBar>
  )
}

export default VerticalDottedStepsBar
